export default __webpack_public_path__ + "static/small-text-do-c0358b68e59f55911a16fd4a8d454308.png";